import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const query = `
  mutation (
    $easyHostTitle1: String,
    $easyHostTitle1_en: String,
    $easyHostTitle1_fr: String,
    $easyHostTitle1_it: String,
    $easyHostTitle1_pt: String,
    $easyHostContent1: String,
    $easyHostContent1_en: String,
    $easyHostContent1_fr: String,
    $easyHostContent1_it: String,
    $easyHostContent1_pt: String,
    $easyHostContent2: String,
    $easyHostContent2_en: String,
    $easyHostContent2_fr: String,
    $easyHostContent2_it: String,
    $easyHostContent2_pt: String,
    $workTitle1: String,
    $workTitle1_en: String,
    $workTitle1_fr: String,
    $workTitle1_it: String,
    $workTitle1_pt: String,
    $workTitle2: String,
    $workTitle2_en: String,
    $workTitle2_fr: String,
    $workTitle2_it: String,
    $workTitle2_pt: String,
    $workContent1: String,
    $workContent1_en: String,
    $workContent1_fr: String,
    $workContent1_it: String,
    $workContent1_pt: String,
    $workContent2: String,
    $workContent2_en: String,
    $workContent2_fr: String,
    $workContent2_it: String,
    $workContent2_pt: String,
    $workImage1: String,
    $workImage2: String,
    $workImage3: String
) {
  updateWhyHostPage (
    easyHostTitle1: $easyHostTitle1,
    easyHostTitle1_en: $easyHostTitle1_en,
    easyHostTitle1_fr: $easyHostTitle1_fr,
    easyHostTitle1_it: $easyHostTitle1_it,
    easyHostTitle1_pt: $easyHostTitle1_pt,
    easyHostContent1: $easyHostContent1,
    easyHostContent1_en: $easyHostContent1_en,
    easyHostContent1_fr: $easyHostContent1_fr,
    easyHostContent1_it: $easyHostContent1_it,
    easyHostContent1_pt: $easyHostContent1_pt,
    easyHostContent2: $easyHostContent2,
    easyHostContent2_en: $easyHostContent2_en,
    easyHostContent2_fr: $easyHostContent2_fr,
    easyHostContent2_it: $easyHostContent2_it,
    easyHostContent2_pt: $easyHostContent2_pt,
    workTitle1: $workTitle1,
    workTitle1_en: $workTitle1_en,
    workTitle1_fr: $workTitle1_fr,
    workTitle1_it: $workTitle1_it,
    workTitle1_pt: $workTitle1_pt,
    workTitle2: $workTitle2,
    workTitle2_en: $workTitle2_en,
    workTitle2_fr: $workTitle2_fr,
    workTitle2_it: $workTitle2_it,
    workTitle2_pt: $workTitle2_pt,
    workContent1: $workContent1,
    workContent1_en: $workContent1_en,
    workContent1_fr: $workContent1_fr,
    workContent1_it: $workContent1_it,
    workContent1_pt: $workContent1_pt,
    workContent2: $workContent2,
    workContent2_en: $workContent2_en,
    workContent2_fr: $workContent2_fr,
    workContent2_it: $workContent2_it,
    workContent2_pt: $workContent2_pt,
    workImage1: $workImage1,
    workImage2: $workImage2,
    workImage3: $workImage3
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success'})
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error' })
  }

}

export default submit;
